import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringReplace'
})
export class StringReplacePipe implements PipeTransform {

  transform(input: any, pattern: any, replacement: any): any {
    if (typeof input !== 'string' || !pattern || !replacement) {
      return input;
    }

    return input.replace(pattern, replacement);
  }
}
